import { IRecipientForTransplantedList } from '@nkr/store/index';

export interface IAliasOption extends IRecipientForTransplantedList {
    label: string
}